import React from 'react';
import hasValidationErrors from 'components/connectedForm/utils/hasValidationErrors';
import { createBackgroundProcess } from 'utils/BackgroundJobs';
import createPostingPreview from '../../views/nominal/NominalPostingPreviewForm';
import createPostedTransactions from '../../views/nominal/PostedTransactionsForm';
import PurchaseRefundPostMutation from 'graphql/mutations/supplier/PurchaseRefundPostMutation.graphql';
import PurchaseRefundPostingPreview from 'graphql/entities/supplier/PurchaseRefundPostingPreview';
import PurchaseRefundTransactions from 'graphql/entities/supplier/PurchaseRefundTransactions';
import { PostSelectButton } from '../../components/SelectButton';
import getClientMutationId from '../../utils/getClientMutationId';

const PURCHASE_REFUND_POSTING_PREVIEW = createPostingPreview(PurchaseRefundPostingPreview);
const PURCHASE_REFUND_POSTED_TRANSACTIONS = createPostedTransactions(PurchaseRefundTransactions);

export const formActions = [
  {
    description: 'Preview Postings',
    triggerModal: {
      modalContent: PURCHASE_REFUND_POSTING_PREVIEW,
      entityId: 'id',
      pageView: true,
      modalProps: {
        formEntityCustomUrl: 'nominal/Postings/supplier/PurchaseRefund',
        forceReadOnly: true,
      },
    },
    performSave: true,
    saveMessage: 'Nominal/VAT Postings Preview',
    btnClass: 'btnInfo',
    individualButton: true,
    condition: displayPreview,
  },
  {
    description: 'View Transactions',
    triggerModal: {
      modalContent: PURCHASE_REFUND_POSTED_TRANSACTIONS,
      entityId: 'id',
      pageView: true,
      modalProps: {
        formEntityCustomUrl: 'nominal/Transactions/supplier/PurchaseRefund',
        forceReadOnly: true,
      },
    },
    btnClass: 'btnInfo',
    individualButton: true,
    condition: displayPosted,
  },
  {
    description: 'Post Refund',
    component: PostSelectButton,
    performSave: true,
    fn: postRefund,
    individualButton: true,
    saveMessage: 'Refund Posted',
    condition: canBePosted,
  },
];

function displayPreview(Refund) {
  if (Refund && Refund.documentStatus) {
    return Refund.documentStatus === 'DRAFT' || Refund.documentStatus === 'RELEASED';
  }
  return false;
}

function displayPosted(Refund) {
  if (Refund && Refund.documentStatus) {
    return Refund.documentStatus === 'POSTED';
  }
  return false;
}

function canBePosted(Refund) {
  if (Refund && Refund.documentStatus) {
    return Refund.documentStatus === 'DRAFT' || Refund.documentStatus === 'RELEASED';
  }
  return false;
}

function postRefund(props) {
  const { values, connectedForm } = props;
  if (hasValidationErrors(connectedForm)) return;
  const input = {
    clientMutationId: getClientMutationId(),
    id: values.id,
  };
  createBackgroundProcess(PurchaseRefundPostMutation, input, props, 'back', 'Post Refund');
}
